module.exports = __webpack_public_path__ + "img/logo.5cc86e4d.svg";